import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import includes from "lodash/includes";
import * as ProviderApi from "api/ProviderApi";
import AccessDenied from "components/common/AccessDenied";
import AsyncLoadContainer from "components/layout/AsyncLoadContainer";
import Button from "components/common/Button";
import GameTemplateAccordionList from "components/provider/widgets/GameTemplateAccordionList";
import ProviderBase from "components/layout/ProviderBase";
import SelectProviderUserForGames from "components/provider/widgets/SelectProviderUserForGames";
import SpinnerTakeover from "components/common/SpinnerTakeover";
import { GENERIC_SEARCH } from "constants/SearchTypes";
import * as UserPermissions from "constants/UserPermissions";
import * as ProviderLinks from "utils/ProviderLinks";
import { handleErrorResponse } from "utils/request";
import { PermissionTypes, userHasPermission } from "utils/permissions/rolesPermissions";

function GameTemplateManagement(props) {
    const location = useLocation();
    const history = useHistory();
    const params = useParams();
    const nodeId = Number(params.nodeId);
    const isAdmin = includes(location.pathname, "/admin");
    const providerId = Number(params.providerId);
    const [loading, setLoading] = useState(false);
    const [nodeInfo, setNodeInfo] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const userId = (selectedUser ? selectedUser.userId : props.nodeId ? props.currentUser?.userId : null);

    const fetchOrgNode = async (nodeId) => {
        setSelectedUser(null);
        setLoading(true);

        await ProviderApi.getNode(nodeId)
            .then((res) => {
                setNodeInfo(res.body);
                if (res.body.users.length) {
                    if (res.body.users?.length === 1) {
                        setSelectedUser(res.body.users[0]);
                    }
                }
            })
            .catch((error) => {
                handleErrorResponse("loading org node", error);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        if (props.canViewGames && nodeId) {
            fetchOrgNode(nodeId);
        }
    }, [nodeId]);

    const handleCreateTemplate = () => {
        let link = ProviderLinks.getLinkLocation("game-template", {
            providerId: providerId,
            nodeId: nodeId,
            isAdmin: isAdmin,
            isDemo: false,
            templateId: "empty"
        });
        if (userId) {
            link = ProviderLinks.getLinkLocation("game-template", {
                providerId: providerId,
                nodeId: nodeId,
                isAdmin: isAdmin,
                isDemo: false,
                templateId: "empty",
            }, `?userId=${userId}`)
        }
        history.push(link);
    }
    const handleSelectUser = (user) => {
        setSelectedUser(user);
    }

    return (
        <ProviderBase
            location={location}
            pageTitle="Template Management"
            nodeId={nodeId}
            providerId={providerId}
            searchConfig={GENERIC_SEARCH}
        >
            {(props.canViewGames) ? (
                <>
                    {(nodeInfo?.nodeId) ? (
                        <>
                            {!userId ? (
                                <SelectProviderUserForGames
                                    onSelectUser={handleSelectUser}
                                    users={nodeInfo.users}
                                />
                            ) : (
                                <div>
                                    <div className="flex padding-bottom-md spaced-content">
                                        <h2 className="flex-1">Template Management</h2>
                                        <Button onClick={handleCreateTemplate}>
                                            Create Template
                                        </Button>
                                    </div>
                                    <AsyncLoadContainer >
                                        <GameTemplateAccordionList userId={userId} />
                                    </AsyncLoadContainer>
                                </div>
                            )}
                        </>
                    ) : (
                        <SpinnerTakeover show={loading}/>
                    )}
                </>
            ) : (
                <AccessDenied/>
            )}
        </ProviderBase>
    );
}
export default connect(
    (state, ownProps) => {
        const userProfile = state.user.userProfile;
        const currentOrgNode = state.entities.orgNode?.current;
        const currentUser = currentOrgNode?.users[0] ? currentOrgNode?.users[0] : userProfile;
        //Permissions
        const canAdminProviderBiGames = userHasPermission(PermissionTypes.ADMIN, UserPermissions.PROVIDER_BI_GAMES, userProfile);
        const canViewProviderBiGames = userHasPermission(PermissionTypes.VIEW, UserPermissions.PROVIDER_BI_GAMES, userProfile);
        const canViewGamesAdmin = userHasPermission(PermissionTypes.VIEW, UserPermissions.GAMES_ADMIN, userProfile);
        const canViewGames = (canAdminProviderBiGames && canViewGamesAdmin) || canViewProviderBiGames;

        return {
            currentUser,
            // Permissions
            canViewGames,
        }
    }
)(GameTemplateManagement);